import { createContext } from "react";

interface ScrollNavigationContextType {
    registerSection: (id: string, el: HTMLElement) => void;
    scrollTo: (id: string) => void;
}

export const ScrollNavigationContext = createContext<ScrollNavigationContextType | undefined>(undefined);
